export class CurrencyFormatter {
    static formatToDollarValue = (value: number): string => {
        if (value === 0) return '$0.00';
        value = Math.round(value * 100) / 100;
        // Explicit en-US: these are USD settlement figures, so the separators must not follow
        // the viewer's locale (a European browser renders "$250 000" for "$250,000").
        const formattedValue = Math.abs(value).toLocaleString('en-US', {
            minimumFractionDigits: value % 1 === 0 ? 0 : 2,
            maximumFractionDigits: value % 1 === 0 ? 0 : 2,
        });
        return value < 1 ? `($${formattedValue})` : `$${formattedValue}`;
    };
}
